module.exports = __webpack_public_path__ + "static/media/IBRLOGO.680052c3.png";